import * as React from 'react';
import { NotationButton } from '../../../../..';
import { Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const StudentDebtRow = ({ value, i18n, formatDate, formatNumber }) => {
    const studentDebt = i18n('service.checkpoints.StudentDebt');
    return (React.createElement(React.Fragment, null,
        value.currentAmount === 0 ? (React.createElement(Paragraph, null, i18n('service.checkpoints.StudentDebt.None'))) : (React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, { key: `${value.currentAmount}` },
                React.createElement(TwoColRow, { className: "ReadReport__studentDebt", label: studentDebt, value: formatNumber(value.currentAmount) }),
                React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.Swedish-Student-Finance')} (${formatDate(value.verificationDate)})` })))),
        value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
            React.createElement(Paragraph, { bold: true },
                i18n('common.note'),
                " ",
                React.createElement(NotationButton, { small: true })),
            React.createElement("div", { className: 'ReadReportContent__NotationContent' },
                React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
};
export default StudentDebtRow;
